
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function TypingIndicator() {
  return (
    <li className="flex items-start gap-2.5">
      <Avatar className="size-12">
        <AvatarImage src="/images/avatar/chat-agent.svg" alt="AI Assistant" />
        <AvatarFallback className="bg-transparent">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <span className="text-primary-foreground text-xs font-medium">AI</span>
          </div>
        </AvatarFallback>
      </Avatar>
      
      <div className="bg-background border rounded-2xl px-4 py-2.5 shadow-sm">
        <div className="flex items-center gap-2">
          <div className="flex gap-1">
            <div className="w-2 h-2 bg-muted-foreground rounded-full animate-pulse"></div>
            <div className="w-2 h-2 bg-muted-foreground rounded-full animate-pulse delay-150"></div>
            <div className="w-2 h-2 bg-muted-foreground rounded-full animate-pulse delay-300"></div>
          </div>
          <span className="text-sm text-muted-foreground">AI is thinking...</span>
        </div>
      </div>
    </li>
  );
}
